'use strict';
/*
  ruckclub — after ruckclub.app. Near-black, neon-lime accent, heavy CONDENSED
  uppercase. Key word in lime with a hard black outline + lime underline bar; a
  small crown signature. Gritty, energetic, outdoors.
*/
const { layoutCue } = require('./_common');
const { FONTS } = require('../lib/draw');

const palette = { bg: '#0e100c', fg: '#f1f3ec', ink: '#0a0b08', accent: '#c2ee00', accent2: '#9bbf00' };

// the RuckClub crown — three peaks, middle tallest
function crown(ctx, cx, cy, w, color) {
  const hw = w / 2, t = w * 0.36, b = w * 0.24;
  ctx.fillStyle = color; ctx.beginPath();
  ctx.moveTo(cx - hw, cy + b);
  ctx.lineTo(cx - hw, cy - t * 0.35);
  ctx.lineTo(cx - hw * 0.42, cy + b * 0.12);
  ctx.lineTo(cx, cy - t);
  ctx.lineTo(cx + hw * 0.42, cy + b * 0.12);
  ctx.lineTo(cx + hw, cy - t * 0.35);
  ctx.lineTo(cx + hw, cy + b);
  ctx.closePath(); ctx.fill();
}

function init(st) { st.s.font = st.tk.registerFamily('ForgeRuck', FONTS.dinCond) || undefined; st.s.pop = 0; }
function onBeat(st, power) { st.s.pop = Math.min(1, st.s.pop + power * 0.5); }

function background(ctx, st) {
  const { W, H } = st; st.s.pop *= 0.84;
  if (!st.overlayMode) {
    const g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#14160f'); g.addColorStop(1, '#080a06');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    const e = (st.m || 0) / 255, gx = st.CX, gy = H * 0.7;
    const rad = ctx.createRadialGradient(gx, gy, 40, gx, gy, W * 0.85);
    rad.addColorStop(0, `rgba(194,238,0,${0.05 + e * 0.06})`); rad.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = rad; ctx.fillRect(0, 0, W, H);
  } else {
    const g = ctx.createLinearGradient(0, H * 0.5, 0, H);
    g.addColorStop(0, 'rgba(8,10,6,0)'); g.addColorStop(1, 'rgba(8,10,6,0.55)');
    ctx.fillStyle = g; ctx.fillRect(0, H * 0.5, W, H * 0.5);
  }
}

function paintToken(ctx, o) {
  const { T, cx, cy, px, scl, alpha, emph, st, ghost } = o, tk = st.tk;
  const pop = emph ? 1 + (st.s.pop || 0) * 0.08 : 1;
  ctx.save(); ctx.globalAlpha = alpha; ctx.translate(cx, cy); ctx.scale(scl * pop, scl * pop);
  ctx.font = tk.font(px, 900, st.s.font); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  if (ghost) { ctx.fillStyle = 'rgba(241,243,236,0.35)'; ctx.fillText(T, 0, 0); ctx.restore(); return; }
  ctx.shadowColor = 'rgba(0,0,0,0.6)'; ctx.shadowBlur = px * 0.16; ctx.shadowOffsetY = px * 0.05;
  ctx.lineJoin = 'round'; ctx.lineWidth = px * 0.26; ctx.strokeStyle = palette.ink; ctx.strokeText(T, 0, 0);
  ctx.shadowColor = 'transparent';
  ctx.fillStyle = emph ? palette.accent : palette.fg; ctx.fillText(T, 0, 0);
  // fatten the glyphs a touch so it carries more weight
  ctx.lineWidth = px * 0.05; ctx.strokeStyle = emph ? palette.accent : palette.fg; ctx.strokeText(T, 0, 0);
  if (emph) { const w2 = (o.tw || ctx.measureText(T).width) / 2, y = px * 0.52; ctx.fillStyle = palette.accent; ctx.fillRect(-w2, y, w2 * 2, px * 0.12); }
  ctx.restore();
}

function drawCue(ctx, st) {
  const anchor = st.mode === 'talk' ? 0.74 : 'center';
  layoutCue(ctx, st, { sizes: { big: 176, mid: 142, small: 86 }, anchor, safeW: 0.94, reveal: 0.16, stagger: 0.045, trail: 1, trans: 0.16, family: st.s.font, paintToken });
}

function overlay(ctx, st) {
  ctx.drawImage(st.tk.vignette(st.overlayMode ? 0.42 : 0.6, 340), 0, 0);
  ctx.fillStyle = palette.accent; ctx.fillRect(0, st.H - 6, st.W * st.progress, 6);
}

module.exports = { id: 'ruckclub', label: 'Sport · bold neon condensed', palette, init, background, drawCue, overlay, onBeat, paintToken };
